import styled from "styled-components";

const BoxWithFiles = styled.label.attrs({
  className:
    "flex justify-center items-center h-20 rounded-lg border-2 border-dashed cursor-pointer",
})``;

const MaxCapacity = styled.p.attrs({
  className: "text-xs font-light text-gray-400",
})``;

const BoxWithoutFiles = styled.div.attrs({
  className:
    "flex flex-col justify-center items-center min-h-[80px] rounded-lg border-2 border-dashed cursor-pointer py-2",
})``;

const Capacity = styled.span.attrs({
  className: "text-xs font-light text-gray-400 ml-1",
})``;

export default {
  BoxWithFiles,
  MaxCapacity,
  BoxWithoutFiles,
  Capacity
};
